
export const currencyList = [
    {code: "TRY", icon: "₺", name: "Türk Lirası"},
    {code: "EUR", icon: "€", name: "Euro"},
    {code: "USD", icon: "$", name: "Dolar"},
    {code: "GBP", icon: "£", name: "İngiliz Poundu"},
    {code: "CHF", icon:"CHF", name: "İsviçre Frangı"}
]